export const selectCategory = state => state.views.syi.category;
